import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dataActiveTitle: "Dashboard",
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setDataActiveTitle: (state, action) => {
      state.dataActiveTitle = action.payload;
    },
  },
});

export const { setDataActiveTitle } = sidebarSlice.actions;
export default sidebarSlice.reducer;
